import React from 'react';
import styled from 'styled-components';
import { FULFILLMENT_FLAG_OPTIONS } from '../../constants/garageServiceClusters';

const DEFAULT_FLAGS = {
  doorstep: false,
  pickupDrop: false,
  roadsideAssistance: false,
  sameDayTurnaround: false,
};

export default function GarageFulfillmentFlags({ value = {}, onChange }) {
  const flags = { ...DEFAULT_FLAGS, ...value };

  const toggle = (key) => {
    onChange?.({ fulfillmentFlags: { ...flags, [key]: !flags[key] } });
  };

  return (
    <Wrap>
      <Label>Fulfillment options</Label>
      <Hint>Independent of service clusters — shown to customers on discovery</Hint>
      <Grid>
        {FULFILLMENT_FLAG_OPTIONS.map((opt) => (
          <FlagBtn
            key={opt.key}
            type="button"
            aria-pressed={!!flags[opt.key]}
            $active={!!flags[opt.key]}
            onClick={() => toggle(opt.key)}
          >
            {opt.label}
          </FlagBtn>
        ))}
      </Grid>
    </Wrap>
  );
}

const Wrap = styled.div`margin-top: 16px;`;
const Label = styled.p`font-size: 12px; font-weight: 600; color: var(--pp-text); margin: 0 0 4px;`;
const Hint = styled.p`font-size: 11px; color: var(--pp-muted); margin: 0 0 10px;`;
const Grid = styled.div`display: grid; grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)); gap: 8px;`;
const FlagBtn = styled.button`
  padding: 10px 12px; font-size: 12px; text-align: left; border-radius: var(--pp-radius-btn); cursor: pointer;
  border: 1px solid ${(p) => (p.$active ? 'var(--pp-brand)' : 'var(--pp-border)')};
  background: ${(p) => (p.$active ? 'var(--pp-brand-bg)' : 'var(--pp-surface)')};
  color: var(--pp-text); font-weight: ${(p) => (p.$active ? 600 : 400)};
`;
